import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
// import waveBlue from "../../images/shap/wave-blue.png";
// import circleDots from "../../images/shap/circle-dots.png";
// import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic1.jpg";
// import pdf from "../../images/icon/pdf.png";
// import doc from "../../images/icon/doc.png";

class ServiceDetail extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Service Details</h1>
									{/* <nav aria-label="breadcrumb" className="breadcrumb-row">
										{/* <ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Service Details</li>
										</ul> 
									</nav> */}
								</div>
							</div>
							{/* <img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/> */}
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15">Why Dental Care is Important</h2>
											<p className="mb-0">Dental care is crucial for maintaining overall health as it not only preserves the integrity of teeth and gums but also plays a significant role in preventing systemic health issues. Regular dental check-ups and hygiene practices help prevent tooth decay, gum disease, and other oral conditions that can impact one's well-being and quality of life.</p>
										</div>
										<div className="row align-items-center">
											<div className="col-md-6 mb-30">
												<ul className="list-check-squer mb-0">
													<li>Prevention of Dental Issues</li>
													<li>Maintaining Oral Health</li>
													<li>Prevention of Systemic Health Issues</li>
													<li>Enhanced Aesthetic Appeal</li>
												<li>Preserving Teeth and Functionality</li>
												</ul>
											</div>
											<div className="col-md-6 mb-30">
												<ul className="list-check-squer mb-0">
													<li>Boosting Self-Confidence</li>
													<li>Early Detection of Oral Disease</li>
													<li>Improved Chewing and Digestion</li>
													<li>Prevention of Bad Breath</li>
												<li>Improving Overall Health</li>
												</ul>
											</div>
										</div>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Services Detailed</h4>
											<p className="mb-0">Gain a significant understanding of the procedures you may have to undergo so that we can help you maintain your dental health and a great smile.</p>
										</div>
										<Accordion defaultActiveKey="11" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>Dental X-Rays</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Dental X-rays are essential diagnostic tools that provide detailed images of your teeth, gums, and jawbone. Bitewing X-rays focus on the upper and lower back teeth, detecting cavities between teeth and bone loss caused by gum disease. Panoramic X-rays, on the other hand, offer a broad view of the entire mouth, including wisdom teeth, jaw alignment, and potential cysts or abnormalities. The procedure is quick, safe, and uses minimal radiation, ensuring your oral health issues are detected early for effective treatment planning.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="1">
												<Accordion.Header>Fillings</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Fillings are a common restorative procedure used to treat cavities and minor tooth damage. The process begins with numbing the affected area to ensure a painless experience. The dentist then removes the decayed portion of the tooth, cleans the area thoroughly, and fills it with a durable material such as composite resin, amalgam, or porcelain. Fillings not only restore the tooth's structure but also prevent further decay, preserving your oral health and maintaining the tooth's natural appearance and function.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="2">
												<Accordion.Header>Dental Crowns</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Dental crowns, often called caps, are used to cover and protect damaged or weakened teeth. This process involves shaping the tooth, taking an impression, and fabricating a custom crown made of materials like porcelain, metal, or ceramic. Crowns restore the tooth’s strength, function, and appearance, often lasting for many years with proper care. They are ideal for teeth that have large fillings, have undergone a root canal, or are severely worn or cracked.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="3">
												<Accordion.Header>Tooth Extractions</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Tooth extractions are performed when a tooth is severely damaged, decayed, or causing overcrowding. The procedure begins with the application of local anesthesia to numb the area. For simple extractions, the dentist uses specialized tools to gently loosen and remove the tooth. For more complex cases, such as impacted teeth, a surgical extraction may be necessary, involving small incisions in the gum. After the extraction, the area is cleaned and may require stitches to aid healing. Your dentist will provide detailed aftercare instructions to promote recovery and comfort.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="4">
												<Accordion.Header>Orthodontic Services</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Orthodontic services focus on diagnosing and treating misaligned teeth and jaws. Treatments include traditional braces, clear aligners, and retainers, all designed to correct issues such as overbites, underbites, crowded teeth, and gaps. The process begins with a thorough consultation, including X-rays and impressions, to create a personalized treatment plan. Over time, these devices gradually shift teeth into their ideal positions, improving both function and aesthetics while enhancing overall oral health.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="5">
												<Accordion.Header>Root Canal</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Root canal therapy is a procedure designed to save a tooth with infected or damaged pulp. The process involves removing the infected tissue, thoroughly cleaning and disinfecting the root canals, and sealing them with a biocompatible material. Often, a crown is placed afterward to protect the tooth and restore its function. Root canals alleviate pain, prevent the spread of infection, and preserve the natural tooth, avoiding the need for extraction.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="6">
												<Accordion.Header>Dental Bridges</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Dental bridges are a solution for replacing missing teeth by anchoring an artificial tooth (or teeth) to adjacent natural teeth or dental implants. The process involves preparing the supporting teeth, known as abutments, and creating a custom bridge to fit securely in place. Bridges restore the ability to chew and speak properly, maintain facial structure, and prevent remaining teeth from shifting out of position. With proper care, bridges can last for many years, providing both functionality and aesthetics.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="7">
												<Accordion.Header>Teeth Whitening</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Teeth whitening is a cosmetic treatment designed to remove stains and discoloration, enhancing the brightness of your smile. Professional in-office whitening treatments use high-concentration bleaching agents activated by special lights to deliver dramatic results in a single session. Alternatively, custom take-home whitening kits allow you to achieve gradual results under your dentist's supervision. Both options are safe and effective, helping you achieve a radiant smile with long-lasting effects.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="8">
												<Accordion.Header>Dentures</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Dentures are removable appliances designed to replace missing teeth, restoring the ability to eat, speak, and smile confidently. Full dentures replace all teeth in an arch, while partial dentures fill gaps left by missing teeth. Modern dentures are made from durable, natural-looking materials and are custom-fitted for comfort and stability. Regular adjustments and proper care are essential to maintaining their fit and functionality over time.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="9">
												<Accordion.Header>Implants</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Dental implants are a permanent solution for replacing missing teeth. The procedure involves surgically placing a titanium post into the jawbone, which acts as a sturdy foundation for a crown, bridge, or denture. Over time, the post fuses with the bone through a process called osseointegration, ensuring a secure and natural-feeling restoration. Implants improve oral function, prevent bone loss, and offer a durable, aesthetically pleasing result.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="10">
												<Accordion.Header>Periodontics</Accordion.Header>
												<Accordion.Body>
												<p className="mb-0">
													Periodontics is a dental specialty focused on the prevention, diagnosis, and treatment of gum diseases like gingivitis and periodontitis. Treatments include deep cleaning (scaling and root planing) to remove plaque and tartar buildup below the gumline, and in severe cases, surgical procedures to restore gum and bone health. Periodontics aims to preserve the supporting structures of the teeth, ensuring long-term oral health and preventing tooth loss.
												</p>
												</Accordion.Body>
											</Accordion.Item>
											</Accordion>

									</div>
									
								</div>
								<div className="col-lg-4">
									<aside >
										{/* <div className="widget">
											<ul className="service-menu">
												<li><Link to="/services"><span>Dental Cleanings and Exams</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/services"><span>X-rays</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/services"><span>Fillings</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/services"><span>Dental Crowns</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/services"><span>Tooth Extractions</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/services"><span>Orthodontic Services</span><i className="fa fa-angle-right"></i></Link></li>
											</ul>
										</div> */}
										<div className="clearfix" style={{ marginBottom: '100px' }}> 
										<div className="head-text mb-30">
											<h4 className="title mb-10">Popular Questions</h4>
											<p className="mb-0">Explore our frequently asked questions for expert insights on maintaining optimal dental health and discover valuable tips for a radiant smile.</p>
										</div>
										<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="6">
												<Accordion.Header>How often should I visit the dentist for regular check-ups?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">It is generally recommended to schedule dental check-ups every six months, but your dentist may suggest more frequent visits based on your individual oral health needs.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="1">
												<Accordion.Header>What is the best way to maintain good oral hygiene at home?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Practicing proper oral hygiene includes brushing your teeth twice a day with fluoride toothpaste, flossing daily, and using an antiseptic mouthwash to reduce bacteria in the mouth.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="2">
												<Accordion.Header>How can I alleviate tooth sensitivity?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Tooth sensitivity can be addressed by using a toothpaste specifically designed for sensitive teeth, avoiding acidic foods and drinks, and consulting your dentist to rule out any underlying issues such as cavities or gum recession.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="3">
												<Accordion.Header>What are the options for teeth whitening?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Professional teeth whitening treatments performed by a dentist are effective and safe. Additionally, at-home whitening kits with dentist supervision are available, offering convenience and gradual results.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="4">
												<Accordion.Header>Are dental X-rays safe, and how often are they necessary?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Dental X-rays are generally safe, as the exposure to radiation is minimal. The frequency of X-rays depends on your oral health needs; your dentist will recommend them when necessary to diagnose and monitor dental issues.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="5">
												<Accordion.Header>How can I replace a missing tooth?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Options for tooth replacement include dental implants, bridges, and dentures. Your dentist will assess your specific situation to recommend the most suitable option for restoring your smile and functionality.</p>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
										</div>
										<div className="widget">
											
												<h5 className="title-head">Fill Out Our Forms Here!</h5>
												<ul className="service-menu">
												<li><Link to="https://forms.wv3.io/form?formId=06e94363-66d2-4e2c-bfb7-d23726889a5b&companyId=1e664556-4582-4516-8686-98fa232fe853"><span>Health History Form English</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="https://forms.wv3.io/form?formId=a08ebbd6-8b00-44f7-b7c1-5e74dd180fd1&companyId=1e664556-4582-4516-8686-98fa232fe853"><span>Health History Form Spanish</span><i className="fa fa-angle-right"></i></Link></li>
												
												</ul>
											
										</div>
										
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				
			</>
		);
	}
}

export default ServiceDetail;